<div class="cart-drawer-overlay" *ngIf="isCartOpen" (click)="toggleCart()"></div>

<div class="cart-drawer" [class.open]="isCartOpen">
    <div class="top">
        <h3>Your Cart</h3>
        <button class="close-cart" (click)="toggleCart()">✖</button>
    </div>
    <ng-container *ngIf="cart?.length;else emptyCart">

        <div class="cart-items">
            <ng-container *ngFor="let cartItem of cart; let i = index; trackBy: identify">
                <ng-container [ngTemplateOutlet]="cartItemTemplate"
                    [ngTemplateOutletContext]="{ $implicit: cartItem, index: i }">
                </ng-container>
            </ng-container>
        </div>

        <div class="cart-total">
            <p>Total: ₹ {{ cartTotal.DiscountPriceTotal }}</p>
            <a class="theme-btn" (click)="checkout()">Proceed to Checkout</a>
        </div>
    </ng-container>

</div>

<ng-template #emptyCart>
    <div class="dAddSec d-flex flex-column align-items-center"><img height="120" width="120" src="assets/images/box.png"
            alt="icon"><span class="text-white pt-2">Your cart is empty.</span>
        <div class="btn-box  mt-2"><a aria-label="shop" class="theme-btn" [routerLink]="['shop']">Shop Now</a></div>
    </div>
</ng-template>



<ng-template #cartItemTemplate let-cartItem let-i="index">
    <div class="cart-item">
        <div class="cart-item-details">
            <a [routerLink]="['/product-detail',cartItem.slug]">
                <img [src]="imageUrl+'/'+ cartItem.imageName" alt="Herbal Tea" class="cart-item-image">
            </a>
            <div>
                <a [routerLink]="['/product-detail',cartItem.slug]">
                    <p class="cart-item-name">{{cartItem.pname}}</p>
                </a>
                <span class="mrp-total"><del>₹ {{ (cartItem.quantity * cartItem.mrp).toFixed(2) }}</del></span>
                <span class="dscnt-total ms-2">₹ {{ (cartItem.quantity * cartItem.discountPrice).toFixed(2) }}</span>
            </div>
        </div>
        <div class="cart-item-quantity">
            <button class="quantity-btn" [disabled]="!cartItem.quantity"
                (click)="changeQuantity(cartItem, true)">-</button>
            <div class="cart-qty">{{ cartItem.quantity }}</div>
            <button class="quantity-btn" (click)="changeQuantity(cartItem, false)">+</button>
        </div>
    </div>
</ng-template>